import { ApiACLRole } from "@incendium/api";
import { Button } from "@mui/material";
import AccessLevel from "Components/AccessLevel/AccessLevel";

interface IOnboardingSuperAdminSkipButtonProps {
  onSkip: () => void;
  label?: string;
}

function OnboardingSuperAdminSkipButton({
  onSkip,
  label = "Skip this step",
}: IOnboardingSuperAdminSkipButtonProps) {
  return (
    <AccessLevel role={ApiACLRole.SUPER_ADMIN} write>
      <Button
        fullWidth
        variant="text"
        color="secondary"
        size="large"
        onClick={onSkip}
      >
        {label}
      </Button>
    </AccessLevel>
  );
}

export default OnboardingSuperAdminSkipButton;
